<script lang="ts" setup>
import { useRuntimeConfig } from '#app'
import LoginForm from '../login-form.vue'
import RegisterForm from '../register-form.vue'
import { AuthTabEnum } from '~/enums'
import { useAuthStore } from '~/stores/auth'

const authStore = useAuthStore()

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  onShowForgotPassword: {
    type: Function,
    required: false,
    default: null,
  },
  selectedTab: {
    type: String,
    required: false,
    default: 'sign-in',
  },
  onChangeTab: {
    type: Function,
    required: true,
  },
  customClass: {
    type: String,
    default: '',
  },
})

const { BRAND_NAME } = useRuntimeConfig().public

const emit = defineEmits(['update:modelValue'])

const tab = ref(props.selectedTab)

const modalVisible = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})

watch(
  () => props.selectedTab,
  (value) => {
    if (value) {
      tab.value = value
    }
  },
)

watch(
  () => tab.value,
  (value) => {
    authStore.enablePreEscape = value !== AuthTabEnum.Login
    props.onChangeTab(value)
  },
)

watch(
  () => modalVisible.value,
  (value) => {
    if (!value) {
      tab.value = AuthTabEnum.Login
    }
  },
)

const overlayOpacity = computed(() => (authStore.warningEscapsed ? 0 : 0.8))

const tabItems = [
  {
    key: AuthTabEnum.Login,
    title: 'Đăng nhập',
    component: LoginForm,
    componentProps: {
      onClose: () => {
        modalVisible.value = false
      },
    },
  },
  {
    key: AuthTabEnum.Register,
    title: 'Đăng ký',
    component: RegisterForm,
    componentProps: {
      onClose: () => {
        modalVisible.value = false
      },
      onSuccess: () => {
        modalVisible.value = false
        authStore.setEnableWelcomeModal(true)
      },
      customClass: props.customClass,
    },
  },
]
</script>
<template>
  <div>
    <BaseModalAuth
      v-model="modalVisible"
      class="scrollbar"
      :custom-class="props.customClass"
      :title="`Chào mừng đến với ${BRAND_NAME}!`"
      :opacity="overlayOpacity"
      :width="728"
    >
      <BaseTabs v-model="tab" :tabs="tabItems" class="invisible-scrollbar" />
    </BaseModalAuth>
  </div>
</template>
